import { validateTidalLicense } from "../../base/index.js";
import { AccessTime } from "./AccessTime.js";
import { AccessTimeFilled } from "./AccessTimeFilled.js";
import { AccountBalance } from "./AccountBalance.js";
import { AccountTree } from "./AccountTree.js";
import { Add } from "./Add.js";
import { AddAPhoto } from "./AddAPhoto.js";
import { AddCircle } from "./AddCircle.js";
import { AddCircleOutline } from "./AddCircleOutline.js";
import { AddTask } from "./AddTask.js";
import { AdminPanelSettings } from "./AdminPanelSettings.js";
import { AllInbox } from "./AllInbox.js";
import { AlternateEmail } from "./AlternateEmail.js";
import { Apartment } from "./Apartment.js";
import { Api } from "./Api.js";
import { Approval } from "./Approval.js";
import { Apps } from "./Apps.js";
import { Archive } from "./Archive.js";
import { ArrowBack } from "./ArrowBack.js";
import { ArrowDownward } from "./ArrowDownward.js";
import { ArrowDropDownCircleOutlined } from "./ArrowDropDownCircleOutlined.js";
import { ArrowForward } from "./ArrowForward.js";
import { ArrowUpward } from "./ArrowUpward.js";
import { Article } from "./Article.js";
import { Assignment } from "./Assignment.js";
import { AttachFile } from "./AttachFile.js";
import { AttachMoney } from "./AttachMoney.js";
import { Bolt } from "./Bolt.js";
import { Bookmark } from "./Bookmark.js";
import { BorderColor } from "./BorderColor.js";
import { BugReport } from "./BugReport.js";
import { BuildCircle } from "./BuildCircle.js";
import { BuildCircleOutlined } from "./BuildCircleOutlined.js";
import { Cached } from "./Cached.js";
import { Calculate } from "./Calculate.js";
import { CalendarToday } from "./CalendarToday.js";
import { CalendarTodayOutlined } from "./CalendarTodayOutlined.js";
import { Call } from "./Call.js";
import { CallOutlined } from "./CallOutlined.js";
import { CameraAlt } from "./CameraAlt.js";
import { Cancel } from "./Cancel.js";
import { CardTravel } from "./CardTravel.js";
import { Category } from "./Category.js";
import { Chat } from "./Chat.js";
import { ChatBubble } from "./ChatBubble.js";
import { ChatBubbleOutline } from "./ChatBubbleOutline.js";
import { Check } from "./Check.js";
import { CheckCircle } from "./CheckCircle.js";
import { CheckCircleOutline } from "./CheckCircleOutline.js";
import { ChevronLeft } from "./ChevronLeft.js";
import { ChevronRight } from "./ChevronRight.js";
import { Circle } from "./Circle.js";
import { Close } from "./Close.js";
import { CloudDone } from "./CloudDone.js";
import { CloudDownload } from "./CloudDownload.js";
import { CloudUpload } from "./CloudUpload.js";
import { Code } from "./Code.js";
import { Collections } from "./Collections.js";
import { CommCenter } from "./CommCenter.js";
import { Commit } from "./Commit.js";
import { Construction } from "./Construction.js";
import { ContactPhone } from "./ContactPhone.js";
import { ContentCopy } from "./ContentCopy.js";
import { ContentPasteOutlined } from "./ContentPasteOutlined.js";
import { CreditCard } from "./CreditCard.js";
import { CreditScore } from "./CreditScore.js";
import { Crop } from "./Crop.js";
import { Dashboard } from "./Dashboard.js";
import { DataArray } from "./DataArray.js";
import { DataUsage } from "./DataUsage.js";
import { DateRange } from "./DateRange.js";
import { Delete } from "./Delete.js";
import { Description } from "./Description.js";
import { DirectionsCar } from "./DirectionsCar.js";
import { DirectionsCarOutlined } from "./DirectionsCarOutlined.js";
import { DoDisturbOn } from "./DoDisturbOn.js";
import { Download } from "./Download.js";
import { Drafts } from "./Drafts.js";
import { DragHandle } from "./DragHandle.js";
import { DragIndicator } from "./DragIndicator.js";
import { Edit } from "./Edit.js";
import { EditLocationAlt } from "./EditLocationAlt.js";
import { EmojiEventsOutlined } from "./EmojiEventsOutlined.js";
import { Equalizer } from "./Equalizer.js";
import { Error } from "./Error.js";
import { ErrorOutline } from "./ErrorOutline.js";
import { Event } from "./Event.js";
import { EventAvailable } from "./EventAvailable.js";
import { EventBusy } from "./EventBusy.js";
import { EventRepeat } from "./EventRepeat.js";
import { ExpandLess } from "./ExpandLess.js";
import { ExpandMore } from "./ExpandMore.js";
import { FiberNew } from "./FiberNew.js";
import { FilterAlt } from "./FilterAlt.js";
import { FilterAltOutlined } from "./FilterAltOutlined.js";
import { FilterList } from "./FilterList.js";
import { Folder } from "./Folder.js";
import { FolderOpen } from "./FolderOpen.js";
import { FormatAlignLeft } from "./FormatAlignLeft.js";
import { FormatBold } from "./FormatBold.js";
import { FormatColorText } from "./FormatColorText.js";
import { FormatItalic } from "./FormatItalic.js";
import { FormatListBulleted } from "./FormatListBulleted.js";
import { FormatShapes } from "./FormatShapes.js";
import { FormatSize } from "./FormatSize.js";
import { FormsManager } from "./FormsManager.js";
import { Fullscreen } from "./Fullscreen.js";
import { GridOn } from "./GridOn.js";
import { GridView } from "./GridView.js";
import { Groups } from "./Groups.js";
import { Headset } from "./Headset.js";
import { HeadsetMic } from "./HeadsetMic.js";
import { HealthAndSafety } from "./HealthAndSafety.js";
import { HelpCenter } from "./HelpCenter.js";
import { HelpCenterOutlined } from "./HelpCenterOutlined.js";
import { HistoryToggleOff } from "./HistoryToggleOff.js";
import { Home } from "./Home.js";
import { Hub } from "./Hub.js";
import { Inbox } from "./Inbox.js";
import { Info } from "./Info.js";
import { InfoOutlined } from "./InfoOutlined.js";
import { InsertDriveFileOutlined } from "./InsertDriveFileOutlined.js";
import { InsertInvitation } from "./InsertInvitation.js";
import { InsertInvitationOutlined } from "./InsertInvitationOutlined.js";
import { InvertColors } from "./InvertColors.js";
import { KeyboardDoubleArrowLeft } from "./KeyboardDoubleArrowLeft.js";
import { KeyboardDoubleArrowRight } from "./KeyboardDoubleArrowRight.js";
import { Language } from "./Language.js";
import { Lightbulb } from "./Lightbulb.js";
import { Link } from "./Link.js";
import { LinkOff } from "./LinkOff.js";
import { ListAlt } from "./ListAlt.js";
import { LocalOffer } from "./LocalOffer.js";
import { LocalOfferOutlined } from "./LocalOfferOutlined.js";
import { LocationOn } from "./LocationOn.js";
import { LocationOnOutlined } from "./LocationOnOutlined.js";
import { Lock } from "./Lock.js";
import { LockOpen } from "./LockOpen.js";
import { Logout } from "./Logout.js";
import { LookupTable } from "./LookupTable.js";
import { Mail } from "./Mail.js";
import { MailOutline } from "./MailOutline.js";
import { Map } from "./Map.js";
import { Menu } from "./Menu.js";
import { Mic } from "./Mic.js";
import { MonetizationOn } from "./MonetizationOn.js";
import { Monitor } from "./Monitor.js";
import { MoreHoriz } from "./MoreHoriz.js";
import { MoreVert } from "./MoreVert.js";
import { MoveToInbox } from "./MoveToInbox.js";
import { MyLocation } from "./MyLocation.js";
import { NearMe } from "./NearMe.js";
import { NearMeDisabled } from "./NearMeDisabled.js";
import { Notes } from "./Notes.js";
import { NotInterested } from "./NotInterested.js";
import { Notifications } from "./Notifications.js";
import { Numbers } from "./Numbers.js";
import { OpenInFull } from "./OpenInFull.js";
import { OpenInNew } from "./OpenInNew.js";
import { PanTool } from "./PanTool.js";
import { PanToolAlt } from "./PanToolAlt.js";
import { PauseCircleOutline } from "./PauseCircleOutline.js";
import { Payments } from "./Payments.js";
import { PaymentsOutlined } from "./PaymentsOutlined.js";
import { People } from "./People.js";
import { Person } from "./Person.js";
import { PersonAdd } from "./PersonAdd.js";
import { PersonAddOutlined } from "./PersonAddOutlined.js";
import { PersonOutlined } from "./PersonOutlined.js";
import { PersonSearch } from "./PersonSearch.js";
import { PestControlRodent } from "./PestControlRodent.js";
import { PestControlRodentOutlined } from "./PestControlRodentOutlined.js";
import { PhoneIphone } from "./PhoneIphone.js";
import { Photo } from "./Photo.js";
import { PictureAsPdf } from "./PictureAsPdf.js";
import { PlayCircleOutline } from "./PlayCircleOutline.js";
import { PlaylistAddCheck } from "./PlaylistAddCheck.js";
import { Polyline } from "./Polyline.js";
import { Preview } from "./Preview.js";
import { Print } from "./Print.js";
import { PublishedWithChanges } from "./PublishedWithChanges.js";
import { QrCodeScanner } from "./QrCodeScanner.js";
import { QuestionAnswer } from "./QuestionAnswer.js";
import { QuestionMark } from "./QuestionMark.js";
import { Quiz } from "./Quiz.js";
import { ReceiptLong } from "./ReceiptLong.js";
import { Redo } from "./Redo.js";
import { Remove } from "./Remove.js";
import { RemoveCircleOutline } from "./RemoveCircleOutline.js";
import { Reorder } from "./Reorder.js";
import { Reply } from "./Reply.js";
import { ReplyAll } from "./ReplyAll.js";
import { RequestQuote } from "./RequestQuote.js";
import { Restore } from "./Restore.js";
import { RotateLeft } from "./RotateLeft.js";
import { RotateRight } from "./RotateRight.js";
import { Route } from "./Route.js";
import { SalesCenter } from "./SalesCenter.js";
import { SaveAlt } from "./SaveAlt.js";
import { Search } from "./Search.js";
import { Send } from "./Send.js";
import { SentimentNeutral } from "./SentimentNeutral.js";
import { SentimentVeryDissatisfied } from "./SentimentVeryDissatisfied.js";
import { SentimentVerySatisfied } from "./SentimentVerySatisfied.js";
import { Settings } from "./Settings.js";
import { SettingsCell } from "./SettingsCell.js";
import { SettingsOutlined } from "./SettingsOutlined.js";
import { Share } from "./Share.js";
import { ShoppingBag } from "./ShoppingBag.js";
import { ShoppingCart } from "./ShoppingCart.js";
import { SimCardDownload } from "./SimCardDownload.js";
import { Star } from "./Star.js";
import { StarHalf } from "./StarHalf.js";
import { StarOutline } from "./StarOutline.js";
import { Summarize } from "./Summarize.js";
import { TableChart } from "./TableChart.js";
import { TableRows } from "./TableRows.js";
import { Task } from "./Task.js";
import { TextSnippet } from "./TextSnippet.js";
import { TextSnippetOutlined } from "./TextSnippetOutlined.js";
import { Textsms } from "./Textsms.js";
import { ThumbDownAlt } from "./ThumbDownAlt.js";
import { ThumbUp } from "./ThumbUp.js";
import { Timeline } from "./Timeline.js";
import { Tour } from "./Tour.js";
import { TrackChanges } from "./TrackChanges.js";
import { TrendingUp } from "./TrendingUp.js";
import { Unarchive } from "./Unarchive.js";
import { Undo } from "./Undo.js";
import { UnfoldMore } from "./UnfoldMore.js";
import { Upload } from "./Upload.js";
import { ViewColumn } from "./ViewColumn.js";
import { Visibility } from "./Visibility.js";
import { VisibilityOff } from "./VisibilityOff.js";
import { VpnKey } from "./VpnKey.js";
import { VpnKeyOff } from "./VpnKeyOff.js";
import { Warning } from "./Warning.js";
import { WarningAmberOutlined } from "./WarningAmberOutlined.js";
import { WifiOff } from "./WifiOff.js";
import { Work } from "./Work.js";
import { WorkspacePremium } from "./WorkspacePremium.js";
import { Wysiwyg } from "./Wysiwyg.js";
import { ZoomIn } from "./ZoomIn.js";
import { ZoomOut } from "./ZoomOut.js";
import { ZoomOutMap } from "./ZoomOutMap.js";
validateTidalLicense();
export {
  AccessTime,
  AccessTimeFilled,
  AccountBalance,
  AccountTree,
  Add,
  AddAPhoto,
  AddCircle,
  AddCircleOutline,
  AddTask,
  AdminPanelSettings,
  AllInbox,
  AlternateEmail,
  Apartment,
  Api,
  Approval,
  Apps,
  Archive,
  ArrowBack,
  ArrowDownward,
  ArrowDropDownCircleOutlined,
  ArrowForward,
  ArrowUpward,
  Article,
  Assignment,
  AttachFile,
  AttachMoney,
  Bolt,
  Bookmark,
  BorderColor,
  BugReport,
  BuildCircle,
  BuildCircleOutlined,
  Cached,
  Calculate,
  CalendarToday,
  CalendarTodayOutlined,
  Call,
  CallOutlined,
  CameraAlt,
  Cancel,
  CardTravel,
  Category,
  Chat,
  ChatBubble,
  ChatBubbleOutline,
  Check,
  CheckCircle,
  CheckCircleOutline,
  ChevronLeft,
  ChevronRight,
  Circle,
  Close,
  CloudDone,
  CloudDownload,
  CloudUpload,
  Code,
  Collections,
  CommCenter,
  Commit,
  Construction,
  ContactPhone,
  ContentCopy,
  ContentPasteOutlined,
  CreditCard,
  CreditScore,
  Crop,
  Dashboard,
  DataArray,
  DataUsage,
  DateRange,
  Delete,
  Description,
  DirectionsCar,
  DirectionsCarOutlined,
  DoDisturbOn,
  Download,
  Drafts,
  DragHandle,
  DragIndicator,
  Edit,
  EditLocationAlt,
  EmojiEventsOutlined,
  Equalizer,
  Error,
  ErrorOutline,
  Event,
  EventAvailable,
  EventBusy,
  EventRepeat,
  ExpandLess,
  ExpandMore,
  FiberNew,
  FilterAlt,
  FilterAltOutlined,
  FilterList,
  Folder,
  FolderOpen,
  FormatAlignLeft,
  FormatBold,
  FormatColorText,
  FormatItalic,
  FormatListBulleted,
  FormatShapes,
  FormatSize,
  FormsManager,
  Fullscreen,
  GridOn,
  GridView,
  Groups,
  Headset,
  HeadsetMic,
  HealthAndSafety,
  HelpCenter,
  HelpCenterOutlined,
  HistoryToggleOff,
  Home,
  Hub,
  Inbox,
  Info,
  InfoOutlined,
  InsertDriveFileOutlined,
  InsertInvitation,
  InsertInvitationOutlined,
  InvertColors,
  KeyboardDoubleArrowLeft,
  KeyboardDoubleArrowRight,
  Language,
  Lightbulb,
  Link,
  LinkOff,
  ListAlt,
  LocalOffer,
  LocalOfferOutlined,
  LocationOn,
  LocationOnOutlined,
  Lock,
  LockOpen,
  Logout,
  LookupTable,
  Mail,
  MailOutline,
  Map,
  Menu,
  Mic,
  MonetizationOn,
  Monitor,
  MoreHoriz,
  MoreVert,
  MoveToInbox,
  MyLocation,
  NearMe,
  NearMeDisabled,
  NotInterested,
  Notes,
  Notifications,
  Numbers,
  OpenInFull,
  OpenInNew,
  PanTool,
  PanToolAlt,
  PauseCircleOutline,
  Payments,
  PaymentsOutlined,
  People,
  Person,
  PersonAdd,
  PersonAddOutlined,
  PersonOutlined,
  PersonSearch,
  PestControlRodent,
  PestControlRodentOutlined,
  PhoneIphone,
  Photo,
  PictureAsPdf,
  PlayCircleOutline,
  PlaylistAddCheck,
  Polyline,
  Preview,
  Print,
  PublishedWithChanges,
  QrCodeScanner,
  QuestionAnswer,
  QuestionMark,
  Quiz,
  ReceiptLong,
  Redo,
  Remove,
  RemoveCircleOutline,
  Reorder,
  Reply,
  ReplyAll,
  RequestQuote,
  Restore,
  RotateLeft,
  RotateRight,
  Route,
  SalesCenter,
  SaveAlt,
  Search,
  Send,
  SentimentNeutral,
  SentimentVeryDissatisfied,
  SentimentVerySatisfied,
  Settings,
  SettingsCell,
  SettingsOutlined,
  Share,
  ShoppingBag,
  ShoppingCart,
  SimCardDownload,
  Star,
  StarHalf,
  StarOutline,
  Summarize,
  TableChart,
  TableRows,
  Task,
  TextSnippet,
  TextSnippetOutlined,
  Textsms,
  ThumbDownAlt,
  ThumbUp,
  Timeline,
  Tour,
  TrackChanges,
  TrendingUp,
  Unarchive,
  Undo,
  UnfoldMore,
  Upload,
  ViewColumn,
  Visibility,
  VisibilityOff,
  VpnKey,
  VpnKeyOff,
  Warning,
  WarningAmberOutlined,
  WifiOff,
  Work,
  WorkspacePremium,
  Wysiwyg,
  ZoomIn,
  ZoomOut,
  ZoomOutMap
};
//# sourceMappingURL=index.js.map
